import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function biharMuzaffarpurPlant() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content">
                        <h2>
                          Bihar Drugs & Organic Chemicals Ltd., Muzaffarpur
                        </h2>

                        <div class="row">
                          <div class="col-sm-6">
                            <img
                              src="../images/MuzaffarpurPlant.jpg"
                              class="img-responsive"
                            />
                          </div>
                          <div class="col-sm-6">
                            <div class="address">
                              <ul>
                                <li>
                                  <img src="../images/person.png" />{" "}
                                  <span>Contact Person Name : </span> Shri Mukul
                                  Mathur
                                </li>
                                <li>
                                  <img src="../images/desi.png" />{" "}
                                  <span>Designation : </span> Additional Charge
                                  Incharge
                                </li>
                                <li>
                                  <img src="../images/home-icon.png" />{" "}
                                  <span>Address : </span> Bela Industrial
                                  Estate, Muzaffarpur-842005 (Bihar)
                                </li>
                                <li>
                                  <img src="../images/cell_icon.gif" />{" "}
                                  <span>Telephone : </span> 0621-2273023
                                </li>
                                <li>
                                  {" "}
                                  <img src="../images/fax.png" />
                                  <span> Fax No. : </span> 0621-2273023
                                </li>
                                <li>
                                  <img src="../images/mouse_icon.gif" />{" "}
                                  <span>E-mail : </span>
                                  idplmukul2018@gmail.com
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <br />

                        <p>
                          The organic-chemical plant, commissioned in 1979, is
                          located at Muzaffarpur in North Bihar which is just 70
                          kms from Patna and is well connected with road and
                          train. In March, 1994, this plant was converted into
                          Subsidiary Unit of IDPL and incorporated (Company
                          Registration No. 03-05753 of 1993-94 with Registrar of
                          Companies, Bihar and having its Registered Office at
                          Muzaffarpur).
                        </p>
                        <p>
                          The plant & its township with 44 flats has an area of
                          65 acres (0.26 million sq. mts.). This is the only
                          plant in the country manufacturing Niacinamide
                          starting from alcohol as principal raw material. It
                          has a locational advantage as 3-4 alcohol producing
                          distilleries and more than 15 sugar mills which feed
                          molasses to these distilleries, are situated within a
                          radius of 150 kms.
                        </p>
                        <p>
                          It has a large production capacity to manufacture
                          Acetaldehyde (7500 metric tonnes), Acetic Acid (4500
                          metric tonnes), Methyl Ethyl Pyridine (1200 metric
                          tonnes), Niacin (500 metric tonnes and Niacinamide
                          (300 metric tonnes). The production process is highly
                          automatic and continuous for Acetaldehyde and Acetic
                          Acid coupled with equipments to avoid any pollution.
                          It also has facilities for treating effluents
                          generated in batch processes of Niacin and
                          Niacinamide.
                        </p>
                        <p>
                          The plant is being upgraded to manufacture 3
                          antibiotics macrolides namely
                          Roxithromycin,Azithromycin and Clarithromycin.The
                          production of these bulk drugs is likely to be started
                          shortly in 2010.
                        </p>
                        <br />

                        <div class="clearfix"></div>

                        <div class="">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14319.840288626832!2d85.3011735!3d26.1979771!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc59f62232f0a92ab!2sKanti+Thermal+Power+Plant!5e0!3m2!1sen!2sin!4v1450350984050"
                            width="100%"
                            height="250"
                            frameborder="0"
                            style={{ border: "0;" }}
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
